import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, s as setBearerAuthToObject, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ReportsApi - axios parameter creator
 * @export
 */
const ReportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSales: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetBrandSales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesReport: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetCategoriesReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySales: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetCategorySales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversionRate: async (startDate, endDate, options = {}) => {
            const localVarPath = `/v1/Reports/GetConversionRate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponsReport: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetCouponsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardAlerts: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetDashboardAlerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCounters: async (options = {}) => {
            const localVarPath = `/v1/Reports/GetDashboardCounters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardRecentOrders: async (limit, options = {}) => {
            const localVarPath = `/v1/Reports/GetDashboardRecentOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardTopProducts: async (startDate, endDate, limit, options = {}) => {
            const localVarPath = `/v1/Reports/GetDashboardTopProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardTrend: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetDashboardTrend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System,Orders,OrderApproval)
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErpErrorLogs: async (limit, options = {}) => {
            const localVarPath = `/v1/Reports/GetErpErrorLogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeographicSales: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetGeographicSales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewCustomers: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetNewCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHeatmap: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetOrderHeatmap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPayments: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetOrderPayments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderShipping: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetOrderShipping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusBreakdown: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetOrderStatusBreakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTotals: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetOrderTotals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSales: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetProductSales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTurnover: async (ReportSearch, options = {}) => {
            const localVarPath = `/v1/Reports/GetProductTurnover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReportSearch, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReportsApi - functional programming interface
 * @export
 */
const ReportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandSales(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandSales(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getBrandSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesReport(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesReport(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getCategoriesReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategorySales(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategorySales(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getCategorySales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversionRate(startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversionRate(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getConversionRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponsReport(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponsReport(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getCouponsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardAlerts(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardAlerts(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboardAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardCounters(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardCounters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboardCounters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardRecentOrders(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardRecentOrders(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboardRecentOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardTopProducts(startDate, endDate, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardTopProducts(startDate, endDate, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboardTopProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardTrend(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardTrend(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboardTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System,Orders,OrderApproval)
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErpErrorLogs(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErpErrorLogs(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getErpErrorLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeographicSales(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeographicSales(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getGeographicSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewCustomers(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewCustomers(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getNewCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderHeatmap(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderHeatmap(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getOrderHeatmap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderPayments(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderPayments(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getOrderPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderShipping(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderShipping(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getOrderShipping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderStatusBreakdown(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderStatusBreakdown(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getOrderStatusBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTotals(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTotals(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getOrderTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSales(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSales(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getProductSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTurnover(ReportSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTurnover(ReportSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getProductTurnover']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReportsApi - factory interface
 * @export
 */
const ReportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportsApiFp(configuration);
    return {
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSales(ReportSearch, options) {
            return localVarFp.getBrandSales(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesReport(ReportSearch, options) {
            return localVarFp.getCategoriesReport(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySales(ReportSearch, options) {
            return localVarFp.getCategorySales(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversionRate(startDate, endDate, options) {
            return localVarFp.getConversionRate(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponsReport(ReportSearch, options) {
            return localVarFp.getCouponsReport(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardAlerts(ReportSearch, options) {
            return localVarFp.getDashboardAlerts(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCounters(options) {
            return localVarFp.getDashboardCounters(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardRecentOrders(limit, options) {
            return localVarFp.getDashboardRecentOrders(limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardTopProducts(startDate, endDate, limit, options) {
            return localVarFp.getDashboardTopProducts(startDate, endDate, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardTrend(ReportSearch, options) {
            return localVarFp.getDashboardTrend(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System,Orders,OrderApproval)
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErpErrorLogs(limit, options) {
            return localVarFp.getErpErrorLogs(limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeographicSales(ReportSearch, options) {
            return localVarFp.getGeographicSales(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewCustomers(ReportSearch, options) {
            return localVarFp.getNewCustomers(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHeatmap(ReportSearch, options) {
            return localVarFp.getOrderHeatmap(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPayments(ReportSearch, options) {
            return localVarFp.getOrderPayments(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderShipping(ReportSearch, options) {
            return localVarFp.getOrderShipping(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusBreakdown(ReportSearch, options) {
            return localVarFp.getOrderStatusBreakdown(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTotals(ReportSearch, options) {
            return localVarFp.getOrderTotals(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(ReportSearch, options) {
            return localVarFp.getOrders(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSales(ReportSearch, options) {
            return localVarFp.getProductSales(ReportSearch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportSearch} [ReportSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTurnover(ReportSearch, options) {
            return localVarFp.getProductTurnover(ReportSearch, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
class ReportsApi extends BaseAPI {
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getBrandSales(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getBrandSales(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getCategoriesReport(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getCategoriesReport(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getCategorySales(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getCategorySales(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getConversionRate(startDate, endDate, options) {
        return ReportsApiFp(this.configuration).getConversionRate(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getCouponsReport(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getCouponsReport(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getDashboardAlerts(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getDashboardAlerts(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getDashboardCounters(options) {
        return ReportsApiFp(this.configuration).getDashboardCounters(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getDashboardRecentOrders(limit, options) {
        return ReportsApiFp(this.configuration).getDashboardRecentOrders(limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getDashboardTopProducts(startDate, endDate, limit, options) {
        return ReportsApiFp(this.configuration).getDashboardTopProducts(startDate, endDate, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getDashboardTrend(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getDashboardTrend(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System,Orders,OrderApproval)
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getErpErrorLogs(limit, options) {
        return ReportsApiFp(this.configuration).getErpErrorLogs(limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getGeographicSales(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getGeographicSales(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getNewCustomers(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getNewCustomers(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getOrderHeatmap(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getOrderHeatmap(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getOrderPayments(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getOrderPayments(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getOrderShipping(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getOrderShipping(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getOrderStatusBreakdown(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getOrderStatusBreakdown(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getOrderTotals(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getOrderTotals(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getOrders(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getOrders(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getProductSales(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getProductSales(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReportSearch} [ReportSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getProductTurnover(ReportSearch, options) {
        return ReportsApiFp(this.configuration).getProductTurnover(ReportSearch, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ReportsApi, ReportsApiAxiosParamCreator, ReportsApiFactory, ReportsApiFp };
//# sourceMappingURL=reports-api.js.map
